import { AuthenticationScheme, } from '@azure/msal-browser';
import { useAppConfig } from '../appConfig';
import { useParamsToGetUserId } from './useParamsToGetUserId';
import { getRedirectState } from './redirectState';
/** Makes a request packet for use in useMsal().instance.loginRedirect */
export const useLoginRequest = (options) => {
    const { scopes, usePopupFlow } = useAppConfig();
    const idFromParams = useParamsToGetUserId();
    // We only need redirect state if we're not using popup flow
    const state = usePopupFlow ? undefined : getRedirectState();
    return Object.assign(Object.assign(Object.assign({}, idFromParams), options), { authenticationScheme: AuthenticationScheme.BEARER, scopes,
        state });
};
